module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-2-9831cb68b336a8323c585e445449046a.jpg";